import { CTAColorVariant } from '~/components/shared/CTAButton';

export const DEFAULT_PROPS = {
  headline:
    'Get a Paramount+ Essential plan included when you sign up for Walmart+',
  disclaimer: 'Essential plan only. Separate registration required.',
  CTAButtonText: 'Claim your free trial',
  CTAButtonVariant: 'primary-blue' as CTAColorVariant,
  CTAButtonLink: 'https://www.walmart.com/plus/plans',
  showImageMobile: true,
  imageDesktop: 'paramount.svg',
  imageAltText: 'Walmart+ and Paramount+ logos',
  hasSecondaryCTAButton: false,
  secondaryCTAButtonText: '',
  secondaryCTAButtonLink: 'https://www.walmart.com/plus/plans',
  secondaryCTAButtonVariant: 'text-link' as CTAColorVariant,
};
